/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


document.querySelector("#filter-3").style.display = "none";
document.querySelector(".collection-sidebar__filter-group:last-of-type > a").classList.remove("js-active");
document.querySelector("#filter-3").classList.remove("js-active");
document.querySelector(".collection-sidebar__filter-group:last-of-type > a").setAttribute("aria-expanded","false");